import axios from 'axios'

/**
 * @desc Fetches all Multi-Store Operators
 */
export const fetchAllMultiStoreOperators = () =>
  axios.get('/authenticated/multi-store-operators').then((res) => res.data)
